/**
 * ProgressBar — 阅读进度、翻译进度
 */

export interface ProgressBarProps {
  /** 0–100 */
  value: number;
  indeterminate?: boolean;
  className?: string;
}

export function ProgressBar({
  value,
  indeterminate = false,
  className = '',
}: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value));
  return (
    <div
      className={`relative w-full h-1.5 rounded-full bg-border-warm dark:bg-border-warm-dark overflow-hidden ${className}`}
    >
      {indeterminate ? (
        <div className="absolute h-full w-1/3 rounded-full bg-oasis animate-pulse" />
      ) : (
        <div
          className="h-full rounded-full bg-oasis transition-all duration-300"
          style={{ width: `${clamped}%` }}
        />
      )}
    </div>
  );
}
